import { useQuery } from '@tanstack/react-query';
import { categoriesAPI } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

export const useCategories = (params = {}) => {
  const { language } = useLanguage();

  // Merge language into params
  const queryParams = { ...params, lang: language };

  return useQuery({
    queryKey: ['categories', queryParams], // Include lang in cache key
    queryFn: () => categoriesAPI.getCategories(queryParams),
    staleTime: 1000 * 60 * 30 // 30 minutes - categories don't change often
  });
};

export const useCategoryDetail = (id, params = {}) => {
  const { language } = useLanguage();

  // Merge language into params
  const queryParams = { ...params, lang: language };

  return useQuery({
    queryKey: ['category', id, queryParams], // Include ID and lang in cache key
    queryFn: () => categoriesAPI.getCategoryById(id, queryParams),
    staleTime: 1000 * 60 * 30, // 30 minutes - category content doesn't change often
    enabled: !!id // Only run query if ID is provided
  });
};

// Category tree hook - hierarchical categories with product counts
export const useCategoryTree = (params = {}) => {
  const { language } = useLanguage();

  // Merge language into params
  const queryParams = { ...params, lang: language };

  return useQuery({
    queryKey: ['categoryTree', queryParams],
    queryFn: () => categoriesAPI.getCategoryTree(queryParams),
    staleTime: 1000 * 60 * 60 // 60 minutes - category structure rarely changes
  });
};
